// LA FORMA DEL LOGO: rectangular, redonda o con marco.
//
// Lissette, 2026-09-23: *"en el perfil se agrega logo pero no tiene un botón de
// eliminarlo y nos gustaría poder escoger la forma en que se ve, es decir
// redonda, rectangular o con marco"*.
//
// Se guarda en las preferencias (`uiPrefs.logoShape`) y la leen el servidor
// —la firma de los correos y la tarjeta digital— y esta pantalla. La lista
// vive también en `deskte-api/src/utils/formaDelLogo.ts`, porque el servidor y
// la pantalla no comparten código; una prueba comprueba que las dos coinciden.
// Si divergen, Mi Perfil ofrecería una forma que al cliente le llega
// rectangular.

export const FORMAS_DEL_LOGO = [
  { id: 'rectangular', es: 'Rectangular', en: 'Rectangular' },
  { id: 'redondo', es: 'Redondo', en: 'Round' },
  { id: 'marco', es: 'Con marco', en: 'Framed' },
];

const IDS = FORMAS_DEL_LOGO.map((f) => f.id);

/**
 * La forma elegida, siempre una de la lista. Lo que no se reconoce es
 * `rectangular`, que es como salía el logo antes de la opción: así nadie ve
 * cambiar su logo sin haber tocado nada.
 */
export function formaDelLogo(prefs) {
  const v = prefs && typeof prefs === 'object' ? prefs.logoShape : undefined;
  return IDS.includes(v) ? v : 'rectangular';
}

/**
 * El estilo del `<img>` para una forma y un tamaño (en px).
 *
 * Es el MISMO dibujo que `atributosDelLogoEnCorreo` en el servidor: redondo
 * recorta a círculo (`cover`, para no deformar un logo apaisado), con marco
 * lleva borde fino, relleno y fondo blanco, y rectangular es el logo tal cual.
 */
export function estiloDelLogo(forma, tam) {
  if (forma === 'redondo') {
    return { width: tam, height: tam, borderRadius: '50%', objectFit: 'cover', display: 'block', flexShrink: 0 };
  }
  if (forma === 'marco') {
    return { width: tam, height: 'auto', objectFit: 'contain', padding: 4, border: '1px solid #d0d7de', borderRadius: 8, background: '#fff', boxSizing: 'content-box', display: 'block', flexShrink: 0 };
  }
  return { width: tam, height: 'auto', objectFit: 'contain', display: 'block', flexShrink: 0 };
}

/**
 * El logo en la TARJETA DIGITAL pública (`/t/<slug>`), que lo pinta más grande
 * que la firma. Rectangular es exactamente el estilo de antes de la opción.
 */
export function estiloDelLogoEnTarjeta(forma) {
  if (forma === 'redondo') {
    return { width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', marginBottom: 14 };
  }
  if (forma === 'marco') {
    return { maxWidth: 150, maxHeight: 54, objectFit: 'contain', padding: 6, border: '1px solid #d0d7de', borderRadius: 10, background: '#fff', boxSizing: 'content-box', marginBottom: 14 };
  }
  return { maxWidth: 150, maxHeight: 54, objectFit: 'contain', marginBottom: 14 };
}
